<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="700"
    :content-class="isDarkMode ? 'dark-mode' : ''"
    :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']"
  >
    <div class="bg-white">
      <v-card-title class="text-h5 bg-grey" tabindex="0">
        <b>{{ $t('Forgot Previous Password') }}</b>
      </v-card-title>

      <p
        class="fs-1-12r pa-4"
        :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']"
        tabindex="0"
      >
        {{
          $t(
            "If you can't remember your previous password, then it will not be possible to access your old files"
          )
        }}.
        <br />
        <b>{{ $t("Are you sure you don't remember your password") }}?</b>
      </p>

      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
          :text="$t('I don\'t remember my previous password')"
          :clickAction="clickOnForgotMyPass"
          width="350"
          btnType="grey"
        />
        <Button
          :text="$t('I remember my previous password')"
          :clickAction="closeDialog"
          width="260"
        />
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import Button from '@/components/BaseComponents/Button/Button.vue'

export default {
  name: 'NotRememberOldPassword',
  props: {
    closeDialog: Function,
    clickOnForgotMyPass: Function,
  },
  data() {
    return {
      dialog: true,
    }
  },
  computed: {
    ...mapGetters(['themeSettings', 'isDarkMode', 'language']),
  },
  components: {
    Button,
  },
}
</script>
